export enum AllocationViewActionIdentifierTypeEnum {
  Uli = 'ULI',
  Slot = 'SLOT',
}
